// extracted by mini-css-extract-plugin
module.exports = {"glossDS":"tokens_glossDS__Eseof","light":"tokens_light__Xu0_A","rebrand":"tokens_rebrand__WVAhY"};